import React, { useCallback, useEffect, useState } from 'react';
import { useWhatsappZapi } from '../../contexts/whatsappZapiContext';
import './WhatsappZapi.css';

function WhatsappZapiContactPicker({ cardId, onOpenParticipantSearch }) {
  const {
    getCardContacts,
    linkContactToCard,
    unlinkContactFromCard,
    openWhatsappZapi,
  } = useWhatsappZapi();
  const [linkedContacts, setLinkedContacts] = useState([]);
  const [message, setMessage] = useState('');
  const [removingContactId, setRemovingContactId] = useState(null);

  const loadLinked = useCallback(async () => {
    if (!cardId) return;
    try {
      const contacts = await getCardContacts(cardId);
      setLinkedContacts(contacts);
    } catch (error) {
      setLinkedContacts([]);
    }
  }, [cardId, getCardContacts]);

  useEffect(() => {
    loadLinked();
  }, [loadLinked]);

  const linkExisting = async (contact) => {
    setMessage('');
    try {
      await linkContactToCard(cardId, { participante_id: contact.id || contact.participante_id, ...contact }, true);
      await loadLinked();
      setMessage('Contato vinculado.');
    } catch (error) {
      setMessage(error.response?.data?.message || 'Erro ao vincular contato.');
    }
  };

  const openSearch = () => {
    setMessage('');
    onOpenParticipantSearch?.({
      title: 'Buscar contato participante',
      emptyText: 'Digite ao menos 2 caracteres para buscar o contato participante.',
      onSelect: linkExisting,
    });
  };

  const removeLinkedContact = async (contact) => {
    const contactId = Number(contact.contact_id || contact.id);
    if (!contactId || !window.confirm('Remover este contato participante do card?')) return;

    setMessage('');
    setRemovingContactId(contactId);
    try {
      await unlinkContactFromCard(cardId, contactId);
      await loadLinked();
      setMessage('Contato participante removido do card.');
    } catch (error) {
      setMessage(error.response?.data?.message || 'Erro ao remover contato participante.');
    } finally {
      setRemovingContactId(null);
    }
  };

  return (
    <div className="zapi-whatsapp-card-picker" data-zapi-whatsapp>
      <label className="zapi-whatsapp-card-picker-title">Contato Participante</label>
      {linkedContacts.length === 0 && <span className="zapi-whatsapp-card-picker-empty">Nenhum contato participante vinculado.</span>}
      {linkedContacts.map((contact) => (
        <div key={contact.contact_id || contact.id} className="zapi-whatsapp-card-picker-linked">
          <div>
            <strong>{contact.participante_name || contact.name || contact.phone_display || contact.phone_normalized}</strong>
            <span>{contact.whatsapp_phone_display || contact.phone_display || contact.phone_normalized}</span>
          </div>
          <div className="zapi-whatsapp-card-picker-linked-actions">
            <button type="button" onClick={() => openWhatsappZapi({ contact_id: contact.contact_id, ...contact })}>Ver conversa</button>
            <button
              type="button"
              className="zapi-whatsapp-card-picker-remove"
              disabled={removingContactId === Number(contact.contact_id || contact.id)}
              onClick={() => removeLinkedContact(contact)}
            >
              {removingContactId === Number(contact.contact_id || contact.id) ? 'Removendo...' : 'Remover'}
            </button>
          </div>
        </div>
      ))}

      <div className="zapi-whatsapp-card-picker-actions">
        <input value="" readOnly onClick={openSearch} placeholder="Buscar contato participante" />
      </div>

      {message && <span className="zapi-whatsapp-card-picker-message">{message}</span>}
    </div>
  );
}

export default WhatsappZapiContactPicker;
